import { CSSProperties, useEffect, useState } from "react";
// import { BASE_URL } from "../../../firebase";
import { portalStore } from "../../../Stores/portal";
import axios from "axios";
import PSIcon from "../../../Assets/Icons/playstation.png";
import XbIcon from "../../../Assets/Icons/xbox.png";
import { Result } from "../../../Model/log";
import { useParams } from "react-router";
import { Col, Row } from "react-bootstrap";
import { CircularProgress } from "@mui/material";
const ResultsAndMatches: React.FC = () => {
  const [results, setResults] = useState<Result[] | null>(null);
  const { id } = useParams();

  const loadResults = () => {
    setResults(null);
    axios
      .get(
        "https://wallof-backend.uc.r.appspot.com" + `/tournament/results/${id}`
      )
      .then((v) => {
        setResults(v.data as unknown as any as Result[]);
      })
      .catch((e) => {
        setResults(null);
        console.error(e);
      });
  };

  useEffect(() => {
    if (id) {
      loadResults();
    }
  }, [id]);
  if (results === null) {
    return <CircularProgress disableShrink />;
  }

  if (results.length === 0) {
    return <h1>No Data</h1>;
  }
  return (
    <Col
      style={{
        width: "100%",
        height: portalStore.portalHeight,
        paddingTop: portalStore.navbarHeight,
        paddingBottom: portalStore.navbarHeight,
        display: "flex",
        flexFlow: "column",
        flexWrap: "wrap",
        overflowY: "scroll",
      }}
    >
      <Row lg={12} sm={12}>
        {/* <h1>Results</h1> */}
      </Row>
      <Row lg={12} sm={12}>
        {results.map((r, i) => (
          <ResultObject r={r} />
        ))}
      </Row>
    </Col>
  );
};

const ResultObject: React.FC<{ r: Result }> = ({ r }) => {
  const winner =
    r.away_goals === r.home_goals
      ? null
      : r.away_goals > r.home_goals
      ? r.away_player
      : r.home_player;

  const winnerStyle = {
    width: "100%",
    display: "flex",
    flexFlow: "row",
    fontWeight: "normal",
    textDecoration: "underline",
  } as CSSProperties;

  const d = new Date(r.timestamp);
  const monthLength = daysInMonth(d.getFullYear(), d.getMonth());

  const loserStyle = { width: "100%", display: "flex", flexFlow: "row" };
  return (
    <>
      <div
        style={{
          display: "flex",
          flexFlow: "row",
          width: "50%",
          border: "1px solid whitesmoke",
          padding: 10,
          height: 100,
        }}
        key={r.id}
      >
        <div
          style={{
            display: "flex",
            flexFlow: "column",
            textAlign: "left",
            width: "75%",
          }}
        >
          <label style={{ color: "gray" }}>
            {`Day ${d.getDate()} of ${monthLength}` + ""}{" "}
          </label>
          <label style={r.home_player === winner ? winnerStyle : loserStyle}>
            <span style={{ width: "80%" }}>{r.H_Player}</span>{" "}
            <span style={{ width: "20%", textAlign: "center" }}>
              {r.home_goals}
            </span>{" "}
          </label>
          <label style={r.away_player === winner ? winnerStyle : loserStyle}>
            <span style={{ width: "80%" }}>{r.A_Player}</span>{" "}
            <span
              style={{
                width: "20%",
                textAlign: "center",
                textDecoration: "none",
              }}
            >
              {r.away_goals}
            </span>{" "}
          </label>
        </div>
        <div
          style={{
            width: "25%",
            textAlign: "center",
            flexFlow: "column",
            justifyItems: "center",
            justifyContent: "center",
            borderLeft: "1px dashed gray",
            margin: "auto auto",
          }}
        >
          <label style={{ margin: "auto auto" }}>Full-time</label>
          <br />
          <img src={XbIcon} height={20} />
        </div>
      </div>
    </>
  );
};

function daysInMonth(year: number, month: number): number {
  // Month is 0-indexed (0 for January, 11 for December)
  return new Date(year, month + 1, 0).getDate();
}

export { ResultsAndMatches };
